import type { NewsGamesList } from "@/data-models/articles.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";

/**
 * Delegates the latest news articles to be managed by our game article auto-updater.
 * The `feature-news` handles injection of latest article and article preview feature.
 * - Setup the required placeholder paths for `feature-news` to hook into
 * - Allows article and article preview data fetching
 * @param game NewsGamesList
 * @returns BaseRoute[]
 */
export default function appRouteArticles(game: NewsGamesList): BaseRoute[] {
  return [
    {
      path: `/${game}/patchnotes`,
      redirect: `/${game}/patchnotes/latest`,
    },
    {
      path: `/${game}/patchnotes/latest`,
      component: "clutch/src/LoadingSpinner/LoadingSpinner.jsx",
    },
  ];
}
